export enum emailFlowState {
  VERIFIED,
  EDIT_START,
  NEW_EMAIL_INPUT,
  TAN,
  OLD_EMAIL_VERIFICATION,
  NEW_EMAIL_VERIFICATION,
  FINISHED,
  ERRORED,
}
